import OrderSummary from "./Cart/OrderSummary";
import CartUpsells from "./Upsells/CartUpsells";

const { __ } = window.wp.i18n;
const { registerPlugin } = window.wp.plugins;
const { ExperimentalOrderMeta, registerCheckoutFilters } = window.wc.blocksCheckout;

const render = () => {

	// Early return where aren't on the checkout page.
	if ( ! document.body.classList.contains( 'woocommerce-checkout' ) ) {
		return null;
	}

	// Render Zap Checkout Order Summary + Upsells.
	return (
		<ExperimentalOrderMeta>
			<OrderSummary />
			<CartUpsells />
		</ExperimentalOrderMeta>
	);
}

// Add Zap Checkout Upsells to WooCommerce Checkout blocks.
if ( ! window.zapCheckoutRegistered ) {
	registerPlugin( 'zap-checkout-upsells', {
		render,
		scope: 'woocommerce-checkout'
	});

	const placeOrderButtonText = (_default_text, _extensions) => {
		return "Place Order";
	};

	// Ensure place order button text is not overwritten by DNA.
	registerCheckoutFilters( 'zap-place-order-button-text', {
		placeOrderButtonLabel: placeOrderButtonText
	} );

	window.zapCheckoutRegistered = true;
}